import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-onboard-overlay-page",
  templateUrl: "./onboard-overlay-page.component.html",
  styleUrls: ["./onboard-overlay-page.component.scss"],
})
export class OnboardOverlayPageComponent implements OnInit {
  @Input() routerLinkUrl = "";
  constructor(private router: Router) {}

  ngOnInit(): void {}

  navigateToPage() {
    if (this.routerLinkUrl) {
      this.router.navigate([`${this.routerLinkUrl}`]);
    }
  }
}
